import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import AssignedCasesList from './AssignedCasesList';

loadDOMComponent({
	selector: 'react-assigned-case-list',
	callback: ({ container, context, props }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<AssignedCasesList />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
